import { defineComponent as _defineComponent } from 'vue'
import { useImpersonation } from '@/store/impersonation.composable';
import { onMounted, ref, watch } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'QuoteBasketOrderReferenceB2B',
  props: {
    orderReference: null,
    customerReference: null,
    orderComment: null
  },
  emits: ["change"],
  setup(__props: any, { emit }: { emit: ({(e: 'change', payload: { orderReference: string, customerReference: string, comment: string }): void}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    orderReference?: string,
    customerReference?: string,
    orderComment?: string
}




const { impersonatingDummyCustomer } = useImpersonation();

const newOrderReference = ref<string | null>(null);
const newCustomerReference = ref<string | null>(null);
const comment = ref<string | null>(null);

onMounted(() => {
    updateOrderReference(props.orderReference);
    updateCustomerReference(props.customerReference);
    updateComment(props.orderComment);
});

watch(() => props.orderReference, updateOrderReference);
watch(() => props.customerReference, updateCustomerReference);
watch(() => props.orderComment, updateComment);

function updateOrderReference(reference: string) {
    if (reference) {
        newOrderReference.value = reference;
    }
}

function updateCustomerReference(reference: string) {
    if (reference) {
        newCustomerReference.value = reference;
    }
}

function updateComment(commentValue: string) {
    if (commentValue) {
        comment.value = commentValue;
    }
}

function onChange(): void {
    emit('change', { orderReference: newOrderReference.value, customerReference: newCustomerReference.value, comment: comment.value });
}

return { __sfc: true,props, emit, impersonatingDummyCustomer, newOrderReference, newCustomerReference, comment, updateOrderReference, updateCustomerReference, updateComment, onChange }
}

})